import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * @typedef {object} GetQuizAttemptData
 * @property {"school" | "classroom"} mode
 * @property {number} school_limit
 * @property {boolean} classroom_overrides_exist
 * @property {boolean} student_overrides_exist
 * @property {boolean} teacher_decides
 */

export const useGetQuizAttempt = () => {
  const [quizAttempt, setQuizAttempt] = useState(
    /** @type {GetQuizAttemptData | null} */ (null)
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { axiosInstance } = useAxios();

  /**
   * Fetch quiz attempt settings
   * @async
   */
  const getQuizAttempt = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await axiosInstance.get(
        `${TENANT_DOMAIN}/quiz/limit/status`
      );

      setQuizAttempt(response?.data?.data || null);
    } catch (err) {
      setQuizAttempt(null);
      if (err?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    quizAttempt,
    loading,
    error,
    getQuizAttempt,
  };
};
